// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ng {\n  stroke: white;\n  stroke-width: 2px;\n}\n.selected {\n  stroke: red;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
